import { Reducer } from 'redux';
import { initialState } from './initialState';
import { actionTypes, ClubState } from 'store/clubs/types/types';

const reducer: Reducer = (state: ClubState = initialState, action): ClubState => {
  const actions: any = {
    [actionTypes.SET_CLUB_DETAILS]: () => ({
      ...state,
      clubDetails: action.payload,
    }),

    [actionTypes.CLEAR_DATA]: () => ({
      ...initialState,
    }),
  };

  return typeof actions[action.type] === 'function' ? actions[action.type]() : state;
};

export default reducer;
